<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div style="margin-bottom: 10px" v-if="system_setting.IsPickOutbound">
        <el-tabs v-model="query.type" @tab-click="tabClick" stretch>
          <el-tab-pane v-for="item in ApplyStateArray" :key="item.id" :name="item.id + ''">
            <template slot="label">
              <!-- <el-badge :value="item.count" :max="99" class="item"> -->
              <span style="margin: 0 10px"> {{ item.name }} </span>
              <!-- </el-badge> -->
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="query.type == 1||!system_setting.IsPickOutbound" class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple"
            v-preventReClick @click="handleDelete">删除</el-button>
          <el-button type="primary" v-if="tableAcl.indexOf('ToPlan') != -1" class="btn primary"
            @click="toPlan">生成采购计划</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">请领单打印</el-dropdown-item>
              <el-dropdown-item command="1">请领单预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button type="primary"  class="btn primary"
            @click="ces">测试</el-button> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div style="margin-right: 10px">
            排序方式 ：
            <el-select v-model="query.sortType" placeholder="请选择" @change="queryChange">
            <el-option label="创建时间" :value='1'></el-option>
            <el-option label="生效时间" :value='3'></el-option>
          </el-select>
          </div>
   
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <div v-if="query.type == 2" class="header">
          <div class="left">
              <el-button v-if="tableAcl.indexOf('PickingStock') != -1" class="btn primary" type="primary" :disabled="multiple" size="small" v-preventReClick @click="handlePickingOrder">生成拣货单</el-button>
            <SelectFilter ref="selectFilter" :options="filterOptions1" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
          </div>
        
      </div>
      <!-- {{ strMessage }} -->
      <div v-if="query.type == 1||!system_setting.IsPickOutbound">
        <div v-if="tableHaeder.length > 0">
          <CustomTable ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange"
            :tableHaeder="tableHaeder" :loading="loading" @resetMethod="reset" :tableHeight="tableHeight"
            @onApproveStatusSuccess="getData" :tableCode="route.name">
            <template slot="before">
              <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
              </el-table-column>
            </template>
            <template slot="after">
              <el-table-column prop="operation" fixed="right" label="操作" width="270">
                <template slot-scope="scope">
                  <el-button type="text" v-preventReClick @click="handleInfo(scope.row)"
                    class="color-blue">查看</el-button>
                  <el-button v-if="
                    scope.row.status == 1 &&
                    isShowApproveButton(scope.row.approverIds)
                  " type="text" v-preventReClick @click="handleApprove(scope.row)"
                    class="margin-left20 color-blue">审核</el-button>
                  <el-button v-else-if="
                    scope.row.status != 1 &&
                    scope.row.status != 2 &&
                    tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                    class="margin-left20 color-blue">编辑</el-button>

                  <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text"
                    v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                  <el-button type="text" class="margin-left20 color-blue" @click="handleCopy(scope.row)"
                    v-if="tableAcl.indexOf('Copy') != -1">复制</el-button>
                  <el-button type="text" v-if="
                    scope.row.state == 0 &&
                    scope.row.status == 2 &&
                    tableAcl.indexOf('ApplyOutStock') != -1
                  " class="margin-left20 color-blue" @click="createApplyOutStock(scope.row)">请领出库</el-button>
                  <el-button type="text" v-if="
                    scope.row.state == 0 &&
                    scope.row.status == 2 &&
                    tableAcl.indexOf('FinishPurchaseApply') != -1
                  " class="margin-left20 color-blue" @click="finishPurchaseApply(scope.row)">终止请领</el-button>
                </template>
              </el-table-column>
            </template>
          </CustomTable>
        </div>
        <div v-else>
          <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData"
            :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
              <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                <img src="../../../../assets/noData.png" width="240" height="240" />
                <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                <div class="empty-rest" @click="reset">恢复默认</div>
              </div>
            </template>
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
            <el-table-column prop="no" width="175" label="申请单号">
              <template slot-scope="scope">
                <span>
                  <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="pressingStateName" width="80" label="紧急标识">
              <template slot-scope="scope">
                <span :class="getPressingStateClass(scope.row.pressingState)">{{
                  scope.row.pressingStateName
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column width="160" label="完成情况">
              <template slot-scope="scope">
                <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(
                  scope.row.totalReceivedNumber,
                  scope.row.totalNumber
                )
                  " color="#42b983" />
              </template>
            </el-table-column>
            <el-table-column label="审批人" width="100" align="center" prop="approverNames">
              <template slot-scope="scope">
                <span>{{ scope.row.approverNames?scope.row.approverNames:'-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="statusName" label="流程状态" width="80">
              <template slot-scope="scope">
                <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
                  @success="getData" :tableCode="route.name"></approve-status>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="applyDeptName" width="100"
              label="请领科室"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="oneLevelWarehouseName" label="目标库房"></el-table-column>
            <el-table-column prop="deliveryTime" min-width="120" label="期望配送时间">
              <template slot-scope="scope">
                {{
                  scope.row.deliveryTime?
                  parseTime(
                    new Date(scope.row.deliveryTime),
                    "{y}-{m}-{d}"
                  ):'-'
                }}
              </template>
            </el-table-column>
            <el-table-column prop="totalNumber" width="95" label="申请总数量"></el-table-column>
            <el-table-column prop="totalAmount" width="95" label="申请总金额"></el-table-column>
            <el-table-column prop="applyStatusName" width="100" label="计划状态"></el-table-column>
            <el-table-column prop="stateName" width="80" label="是否完成"></el-table-column>
            <el-table-column prop="categoryName" width="80" label="类型"></el-table-column>
            <el-table-column prop="createdUserName" width="80" label="申请人"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="ownerDeptName" width="100"
              label="所属科室"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.remark?scope.row.remark:'-' }}
              </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间" width="170">
              <template slot-scope="scope">
                {{
                  parseTime(
                    new Date(scope.row.createdTime),
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column prop="effectiveTime" label="生效时间" width="170">
              <template slot-scope="scope">
                {{
                  parseTime(
                    new Date(scope.row.effectiveTime),
                    "{y}-{m}-{d} {h}:{i}:{s}"
                  )
                }}
              </template>
            </el-table-column>
            <el-table-column prop="operation" fixed="right" label="操作" width="270">
              <template slot-scope="scope">
                <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
                <el-button v-if="
                  scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
                " type="text" v-preventReClick @click="handleApprove(scope.row)"
                  class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                  class="margin-left20 color-blue">编辑</el-button>

                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <el-button type="text" class="margin-left20 color-blue" @click="handleCopy(scope.row)"
                  v-if="tableAcl.indexOf('Copy') != -1">复制</el-button>
                <el-button type="text" v-if="
                  scope.row.state == 0 &&
                  scope.row.status == 2 &&
                  tableAcl.indexOf('ApplyOutStock') != -1
                " class="margin-left20 color-blue" @click="createApplyOutStock(scope.row)">请领出库</el-button>
                <el-button type="text" v-if="
                  scope.row.state == 0 &&
                  scope.row.status == 2 &&
                  tableAcl.indexOf('FinishPurchaseApply') != -1
                " class="margin-left20 color-blue" @click="finishPurchaseApply(scope.row)">终止请领</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="query.type == 2">
         <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData1"
            :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
              <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                <img src="../../../../assets/noData.png" width="240" height="240" />
                <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                <div class="empty-rest" @click="reset">恢复默认</div>
              </div>
            </template>
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
            <el-table-column prop="supplierProductNo" min-width="180" label="供应商产品编码"></el-table-column>
             <el-table-column prop="productName" min-width="150" label="产品名称"></el-table-column>
              <el-table-column prop="specName" min-width="150" label="规格型号"></el-table-column>
                     <el-table-column prop="number" width="80" label="请领数量"></el-table-column>
            <el-table-column prop="notReceivedNumber" width="80" label="未领数量"></el-table-column>
            <el-table-column prop="pickingStockNo" min-width="160" label="拣货单号">
              <template slot-scope="scope">
                {{ scope.row.pickingStockNo??'-' }}
              </template>
            </el-table-column>
            <el-table-column  width="80" label="未拣数量">
              <template slot-scope="scope">
                <!-- scope.row.number - scope.row.pickedNumber  -->
                {{  getUnpickedQuantity(scope.row)}}
              </template>
            </el-table-column>
            <el-table-column prop="pickedNumber" width="80" label="已拣数量"></el-table-column> 
            <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
            <el-table-column prop="manufacturerName" min-width="180" label="生产厂家"></el-table-column> 
            <el-table-column prop="supplierName" min-width="180" label="供应商"></el-table-column> 
            <el-table-column prop="applyNo" min-width="150" label="请领单号"></el-table-column>  
            <el-table-column prop="deptName" width="80" label="请领科室"></el-table-column>  
            <el-table-column prop="oneLevelWarehouseName" min-width="130" label="目标库房"></el-table-column>
            <el-table-column prop="applyCategoryName" width="80" label="请领类型"></el-table-column>  
            <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
          </el-table>
      </div>



      <el-dialog :title="'是否终止当前请领单' + finishForm.no" :visible.sync="finishVisible" width="40%"
        :close-on-click-modal="false">
        <el-form ref="finishForm" :model="finishForm" :rules="finishFormRules" label-width="90px">
          <el-row>
            <el-col>
              <el-form-item prop="reason" label="终止原因">
                <el-input v-model="finishForm.reason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="finishVisible = false">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="finishSubmit">确
            定</el-button>
        </div>
      </el-dialog>
      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetPurchaseApplys,
  GetPurchaseApplyPrintData,
  // CreatePurchasePlanByApplyIds,
  RemovePurchaseApply,
  FinishPurchaseApply,
  ChatMessages,
  GetToPickDetailViewModels,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  WhetherOptions,
  PlanStateOptions,
  PurchaseApplyCategoryOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";
export default {
  mixins: [BaseListMixin, GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetPurchaseApplys,
      RemoveAction: RemovePurchaseApply,
      PrintAction: GetPurchaseApplyPrintData,
      // exportAction: ExportAcceptOutStock,
      editPath: "purchase-apply-edit",
      // 查询条件
      query: {

        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        state: 0,
        stateName: 0,
        type:'1',
            loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      },
      tableData1: [],
      WhetherOptions: WhetherOptions,
      PlanStateOptions: PlanStateOptions,
      PurchaseApplyCategoryOptions: PurchaseApplyCategoryOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "是否已完成",
          type: "select",
          code: "state",
          data: WhetherOptions,
          defaultValue: 0,
        },
        {
          name: "状态",
          type: "select",
          code: "applyStatus",
          data: PlanStateOptions,
        },
        {
          name: "目标库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getOneLevelWarehouses,
          data: [],
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce1,
          data: [],
        },
        {
          name: "科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "请领科室",
          type: "select",
          code: "applyDeptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "类型",
          type: "select",
          code: "category",
          data: PurchaseApplyCategoryOptions,
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "期望配送时间",
          type: "date",
          startDateCode: "deliveryTimeStart",
          endDateCode: "deliveryTimeEnd",
          code: "deliveryTimeDate",
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "快捷筛选",
          type: "myCheckbox",
          code: "isActiveAndPendingApproval",
          options: [
            {
              id: 1,
              name: "仅看生效或待自己审批的",
            },
          ],
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
      ],
      filterOptions1:[
      
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
         {
          name: "生产厂家",
          type: "input",
          code: "manufacturerName",
        },
        {
          name: "是否拣货完成",
          type: "select",
          code: "isFinishPicking",
          data: WhetherOptions,
          defaultValue: 0,
        },
        {
          name: "拣货单号",
          type: "input",
          code: "pickingStockNo",
        },
        {
          name: "请领单号",
          type: "input",
          code: "applyNo",
        },
        {
          name: "请领科室",
          type: "select",
          code: "applyDeptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "请领类型",
          type: "select",
          code: "category",
          data: PurchaseApplyCategoryOptions,
        },
        {
          name: "目标库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getOneLevelWarehouses,
          data: [],
        },
      ],
      ApplyStateArray: [
        {
          id: 1,
          name: "请领单",
        },
        {
          id: 2,
          name: "待拣货明细",
        },
      ],
      finishVisible: false,
      finishForm: {},
      finishFormRules: {
        reason: [
          {
            required: true,
            message: "请输入终止原因",
            trigger: "blur",
          },
        ],
      },
      strMessage: "",
    };
  },
  methods: {

    handleCopy(row) {
      this.routePushWithParams("/purchase-apply-edit", this.query, {
        formMode: 2,
        id: row.id,
        isCopy: 1,
      });
    },
    //
    toPlan() {
      console.log(this.ids);

      const length = this.ids.length;
      if (length === 0) {
        this.$my_message(`请选择数据`, "warning");
        return;
      }

      const isCategoryEqual = this.multipleSelection.every(
        (obj) => obj.category == this.multipleSelection[0].category
      );
      if (!isCategoryEqual) {
        this.$my_message(`只能勾选同一种类型的请领单`, "warning");
        return;
      }
      let statusDatas = this.multipleSelection.filter((e) => e.status != 2);
      if (statusDatas != null && statusDatas.length > 0) {
        this.$my_message(
          `存在不是生效状态的请领单，不能生成采购计划`,
          "warning"
        );
        return;
      }
      let stateDatas = this.multipleSelection.filter((e) => e.state == 1);
      if (stateDatas != null && stateDatas.length > 0) {
        this.$my_message(`存在已完成的请领单，不能生成采购计划`, "warning");
        return;
      }

      let applyStatusDatas = this.multipleSelection.filter(
        (e) => e.applyStatus
      );
      if (applyStatusDatas != null && applyStatusDatas.length > 0) {
        this.$my_message(`不能勾选已生成或计划生成中的请领单`, "warning");
        return;
      }

      let oneLevelWarehouseIds = Array.from(
        new Set(this.multipleSelection.map((e) => e.oneLevelWarehouseId))
      );
      if (oneLevelWarehouseIds != null && oneLevelWarehouseIds.length > 1) {
        this.$my_message(
          `所选请领单存在目标库房不一致，不能生成采购计划`,
          "warning"
        );
        return;
      }

      const h = this.$createElement;
      let content = [h("p", "确定要生成采购计划吗？")];
      let otherOneLevelWarehouseIds = this.multipleSelection.filter(
        (e) =>
          e.oneLevelWarehouseId != this.multipleSelection[0].oneLevelWarehouseId
      );
      if (otherOneLevelWarehouseIds && otherOneLevelWarehouseIds.length > 0) {
        // message += "<br/><span style='color:red'>存在目标库房不一致</span>";
        content.push(
          h(
            "p",
            {
              style: "color:red",
            },
            "存在目标库房不一致"
          )
        );
      }

      this.$confirm("提示", {
        title: "提示",
        type: "warning",
        message: h("div", content),
      }).then(() => {
        // return CreatePurchasePlanByApplyIds({ ids: this.ids })
        this.query.applyIds = this.ids;
        this.routePushWithParams("/spd-purchase-plan-edit", this.query, {
          formMode: 1,
        });
      });
    },
    createApplyOutStock(row) {
      // this.purchaseApplyId = row.id
      // this.applyOutStockEditVisible = true
      // this.purchaseApplyNo = row.no
      // this.$router.push("/apply-out-stock-edit?formMode=1&applyId=" + row.id);
      this.$router.push({
        name: "ApplyOutStockEdit", // module里的code
        params: this.query,
        query: {
          applyId: row.id,
          formMode: 1,
          resouce: 1,
        }, //resouce 来源，在请领出库页面中判断
      });
    },
    finishPurchaseApply(row) {
      if (row.state == 1) {
        this.$my_message("该请领单已完成，不用在终止");
        return;
      }

      this.finishForm = {
        no: row.no,
        id: row.id,
        reason: "",
      };
      this.finishVisible = true;
    },
    finishSubmit() {
      this.$refs["finishForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        FinishPurchaseApply(this.finishForm).then((res) => {
          this.$my_message(`已终止请领单`, "success");
          this.finishVisible = false;
          this.getData();
        });
      });
    },
    tabClick(tab) {
     this.query.pageIndex = 1
      this.query.type = tab.name
      this.getData()
      // this.getData()
    },
    handlePickingOrder(){
      if(this.multipleSelection.length == 0){
        this.$my_message(`请选择请明细`, "warning");
        return;
      }
      
      // 校验1: 检查是否所有选中明细的未拣数量大于0
      const hasInvalidToPickNumber = this.multipleSelection.some(item => !((item.number - item.pickedNumber) > 0));
      if (hasInvalidToPickNumber) {
        this.$my_message(`请勾选未拣完成且相同请领单的明细`, "warning");
        return;
      }
      
      // 校验2: 检查是否所有选中明细的科室(deptId)、申请科室(applyDeptId)和目标库房(oneLevelWarehouseId)都相同
      const firstItem = this.multipleSelection[0];
      const firstApplyDeptId = firstItem.applyDeptId;
      const firstWarehouseId = firstItem.oneLevelWarehouseId;
      
      const hasDifferentApplyDeptId = this.multipleSelection.some(item => item.applyDeptId != firstApplyDeptId);
      const hasDifferentWarehouseId = this.multipleSelection.some(item => item.oneLevelWarehouseId != firstWarehouseId);
      
      
      if ( hasDifferentApplyDeptId || hasDifferentWarehouseId) {
        this.$my_message(`只能勾选未拣完成且同科室同目标库房的明细`, "warning");
        return;
      }
      let parentIds = Array.from(
        new Set(this.multipleSelection.map((e) => e.parentId))
      ).join(';')
      
      let ids = this.ids.join(';')
      this.$router.push({
        name: "PickingStockEdit", 
        params: this.query,
        query: {
          formMode: 1,
          pickingIds:parentIds,
          ids
        },
      });
    },
    getUnpickedQuantity(row){
      if(row.number-row.pickedNumber>0){
        let num = row.number-row.pickedNumber
        if(num>row.notReceivedNumber){
          return row.notReceivedNumber
        }
        return num
      }else{
        return 0
      }
    },
    // print (command) {
    //   const length = this.ids.length
    //   if (length !== 1) {
    //     this.$my_message('请选择一条数据', 'warning')
    //     return
    //   }

    //   var id = this.ids[0]
    //   GetPurchaseApplyPrintData({ id: id, type: command })
    //     .then(res => {
    //       var result = res.returnData

    //       var printData = this.printDataConvert(result.printData)
    //       this.sendPrintMessage(JSON.stringify(printData));
    //       this.getData();
    //     })
    // },
  },
  created() {
    // 分页组件默认值需要早created
    // if (this.$route.params && JSON.stringify(this.$route.params) != '{}') {
    //   this.query = this.$route.params
    // }
  },
  mounted() {
    // 查询组件默认值需要在mounted
    // if (this.$route.params && JSON.stringify(this.$route.params) != '{}') {
    //   this.$refs["selectFilter"].query = this.query
    // }
    this.query.sortType = 1
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 500px;
  // margin-bottom: 10px;
}
</style>
